import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { applicationApi } from "../services/appln";
import { ResourceAssessmentApi } from "../services/ResourceAssessmentApi";

const store = configureStore({
  reducer: {
    [applicationApi.reducerPath]: applicationApi.reducer,
    [ResourceAssessmentApi.reducerPath]: ResourceAssessmentApi.reducer,
  },
  // Adding the api middleware enables caching, invalidation, polling,
  // and other useful features of `rtk-query`.
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(applicationApi.middleware)
      .concat(ResourceAssessmentApi.middleware),
});

// optional, but required for refetchOnFocus/refetchOnReconnect behaviors
// see `setupListeners` docs - takes an optional callback as the 2nd arg for customization
setupListeners(store.dispatch);

export default store;
